"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = ErrorBoundary;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = require("prop-types");
var _ErrorBoundary = require("./ErrorBoundary.styled");
var _Button = require("../Button/Button");
function ErrorBoundary(_ref) {
  var _ref$header = _ref.header,
    header = _ref$header === void 0 ? 'Something went wrong!' : _ref$header,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description;
  return /*#__PURE__*/_react["default"].createElement(_ErrorBoundary.Wrapper, null, /*#__PURE__*/_react["default"].createElement("h1", null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    style: {
      color: '#9B2012'
    },
    icon: _freeSolidSvgIcons.faExclamationTriangle
  }), header), /*#__PURE__*/_react["default"].createElement("p", null, description), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    onClick: function onClick() {
      return window.location.reload();
    },
    color: 'destructive'
  }, "Refresh"));
}
ErrorBoundary.propTypes = {
  header: _propTypes.string,
  description: _propTypes.string
};